import React from 'react';

const CompanyCityFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 17H3V3H15V7.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M7 17V12H9.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M6.5 6.5H11M6.5 9H10" strokeLinecap="round" strokeWidth="1.5" />
      <path
        d="M15.5714 17.943C15.2051 18.2989 14.6254 18.2989 14.2591 17.943C13.2903 17.0027 11.5938 15.1011 11.5938 13.3211C11.5938 11.4869 13.0806 10 14.9148 10C16.749 10 18.2358 11.4869 18.2358 13.3211C18.2358 15.1011 16.5393 17.0027 15.5714 17.943Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.9112 12.9766C14.7745 12.9766 14.6644 13.0877 14.6653 13.2234C14.6653 13.3601 14.7764 13.4703 14.9122 13.4703C15.0479 13.4703 15.159 13.3592 15.159 13.2234C15.159 13.0867 15.0489 12.9766 14.9112 12.9766"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default CompanyCityFilterIcon;
